import React from 'react'
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom'
import ProverHome from '../ProverHome.jsx'
import ProverBookingRelease from './ProverBookingRelease.jsx'
import { ProverPrivacy, ProverTerms, ProverPortalSafe, ProverManagementSafe, ProverNotFound } from './ProverStaticPages.jsx'

export default function ProverReleaseApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ProverHome />} />
        <Route path="/agenda" element={<ProverBookingRelease />} />
        <Route path="/portal" element={<ProverPortalSafe />} />
        <Route path="/gestion" element={<ProverManagementSafe />} />
        <Route path="/login" element={<ProverManagementSafe />} />
        <Route path="/privacidad" element={<ProverPrivacy />} />
        <Route path="/privacy" element={<ProverPrivacy />} />
        <Route path="/terminos" element={<ProverTerms />} />
        <Route path="/terms" element={<ProverTerms />} />
        <Route path="/salir" element={<Link to="/">Volver a ProVer</Link>} />
        <Route path="/logout" element={<Link to="/">Volver a ProVer</Link>} />
        <Route path="*" element={<ProverNotFound />} />
      </Routes>
    </BrowserRouter>
  )
}
